import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Box, Tabs } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'

import { useModuleAvailability } from 'modules/core/hooks/useModuleAvailability'

import type Location from 'modules/locations/store/models/Location'

import useLocationsTabs from './tabs'

interface Props {
  location: Location
}

const CommonHeader = ({ children, location }: React.PropsWithChildren<Props>) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { moduleAvailability } = useModuleAvailability(AvailableModules.space_control)
  const tabs = useLocationsTabs(location.id, moduleAvailability.available)

  return (
    <Box width="full">
      <Tabs
        currentId={pathname}
        onTabClicked={(tabId) => {
          tabs.find((tab) => tab.href === tabId)?.onClick?.()
          navigate(tabId)
        }}
        hasAdditionalPadding
      >
        {tabs.map((tab) => (
          <Tabs.Tab key={tab.href} id={tab.href} label={tab.name} />
        ))}
      </Tabs>
      <Box width="full" alignItems="center" paddingTop="s24">
        {children}
      </Box>
    </Box>
  )
}

export default CommonHeader
